// "On the 8s" segment bumper (TWC-style) — a branded card that interrupts the
// loop at clock times ending in 8 and rolls into the local conditions segment.
// CSS-keyframe driven (encoder-safe).
export function OnTheEightsSlide({ now, cities = [] }) {
  const atlanta = (cities || []).find((c) => c.id === "atlanta") || (cities || [])[0];
  const timeStr = (now || new Date()).toLocaleTimeString("en-US", { timeZone: "America/New_York", hour: "numeric", minute: "2-digit", hour12: true }) + " ET";

  return (
    <div data-testid="on-the-eights-slide" className="relative h-full w-full overflow-hidden" style={{ background: "#07192f" }}>
      <div className="eights-sheen absolute inset-0" />
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #ffffff 0 2px, transparent 2px 36px)" }} />

      <div className="relative flex h-full w-full flex-col items-center justify-center text-center text-white">
        <div className="eights-rise font-oswald text-[30px] font-bold uppercase tracking-[0.5em] text-[#4cc9f0]">
          Your Georgia Forecast
        </div>

        <div className="eights-dial mt-6 flex items-baseline gap-6">
          <span className="font-oswald text-[220px] font-black leading-[0.8] tracking-tight text-[#ffd60a] drop-shadow-[0_18px_50px_rgba(0,0,0,0.5)]">8</span>
          <span className="font-oswald text-[96px] font-black uppercase leading-none tracking-wide">on the&nbsp;8s</span>
        </div>

        <div className="eights-rise mt-10 flex items-center gap-6 font-oswald text-[34px] font-bold uppercase tracking-widest text-white/90" style={{ animationDelay: "140ms" }}>
          <span className="rounded-[4px] bg-[#d90429] px-6 py-2">{timeStr}</span>
          {atlanta?.current_temp != null && (
            <span data-testid="eights-temp" className="rounded-[4px] bg-white/10 px-6 py-2">Atlanta {Math.round(atlanta.current_temp)}°</span>
          )}
        </div>

        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 font-oswald text-[24px] font-black uppercase tracking-[0.4em] text-white/70">
          G<span className="text-[#ffd60a]">W</span>N · Live Conditions Next
        </div>
      </div>
    </div>
  );
}
